import FqApi from '@/services/fq-api'

const baseUrl = '/systemmessage'

export default {
  async getActiveMessage() {
    const result = await FqApi.get(`${baseUrl}/active`)
    return result.data
  }
}

